import * as Yup from 'yup';

export const AtualizarSenhaValidacao = Yup.object().shape({
  senha: Yup.string().required('Informe a senha!').min(4, 'Informe no mínimo 4 caracteres!'),
  confirmacao: Yup.string()
    .required('Confirme sua senha!')
    .oneOf([Yup.ref('senha')], 'A confirmação diverge da senha criada!'),
});
